<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.provinceId"
              placeholder="请选择省区"
              style="width:100%"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.year"
              placeholder="请选择年份"
              style="width:100%"
            >
              <el-option
                v-for="item in yearOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.month"
              placeholder="请选择年份"
              style="width:100%"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="exportFun(0)"
        @exportPicUrl="exportFun(1)"
      />
    </div>
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import ViewDialog from '@/views/terminalModule/visit/components/viewDialog'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadStoreVisitReportGoodKeepListDataApi, loadStoreVisitReportGoodKeepExportDataApi } from '@/api/storeVisitReport'
export default {
  name: 'SystemVisitReportGoodKeep',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'visit_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_visit_report_good_keep_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['store_visit_report_good_keep_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['store_visit_report_good_keep_export'],
            prop: 'export',
            label: '导出(含图片路径)',
            method: 'exportPicUrl'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            provinceId: '',
            year: '',
            month: ''
          }
        }
      },
      id: null, // 选中的单据ID
      baseUrl: process.env.VUE_APP_BASE_API,
      dialogViewTitle: '查看日常拜访',
      dialogViewVisible: false,
      eventType: 'add',
      yearOptions: [],
      monthOptions: [],
      provinceOptions: []
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 's.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 's.city_name', width: 80 },
      { prop: 'countyName', label: '区县', filterColumn: 's.county_name', width: 80 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 130 },
      { prop: 'storeName', label: '店名', filterColumn: 's.store_name', width: 160 },
      { prop: 'address', label: '地址', filterColumn: 's.address', width: 180 },
      { prop: 'ownerName', label: '店主', filterColumn: 's.owner_name', width: 80 },
      { prop: 'phone', label: '电话', filterColumn: 's.phone', width: 110 },
      { prop: 'visitUserName', label: '拜访人', filterColumn: 'r.visit_user_name', width: 110 },
      { prop: 'visitDateStr', label: '拜访日期', filterColumn: 'DATE_FORMAT(r.visit_date,\'%Y-%m-%d\')', width: 110 },
      { prop: 'displayGridStr', label: '陈列格数', filterColumn: '(case r.display_grid when 1 then "小于1格(背柜)" when 2 then "1格(背柜)" when 3 then "2格(背柜)" when 4 then "3格(背柜)" when 5 then "大于3格(背柜)" else "" end)', width: 130 },
      { prop: 'displayCount', label: '陈列条数', filterColumn: 'r.display_count', width: 130 },
      { prop: 'pic', label: '图片', width: 700, isImage: true },
      { prop: 'description', label: '优秀规则', width: 110, filterColumn: 'r.remark' },
      { prop: 'remark', label: '备注', filterColumn: 'r.remark' }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    let currentDate = new Date()
    let currentYear = currentDate.getFullYear()
    this.yearOptions = [{ label: (currentYear - 1) + '年', data: (currentYear - 1) }, { label: currentYear + '年', data: currentYear }]
    this.masterList.tableQuery.search.year = currentYear
    this.monthOptions = []
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({ label: i + '月', data: i })
    }
    this.masterList.tableQuery.search.month = currentDate.getMonth() + 1
    this.$nextTick(() => {
      this.initProvinceSelectData()
    })
  },
  methods: {
    // 请求数据
    requestData () {
      if (this.masterList.tableQuery.search.provinceId === null || this.masterList.tableQuery.search.provinceId === '' || this.masterList.tableQuery.search.provinceId === undefined) {
        this.$message({
          message: '请选择省区',
          type: 'warning'
        })
        return
      }
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreVisitReportGoodKeepListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        data.forEach(element => {
          let pic = []
          for (let i = 1; i <= 10; i++) {
            if (element['pic' + i] && element['pic' + i].length > 0) {
              pic.push(this.baseUrl + element['pic' + i])
            }
          }
          element.pic = pic
        })
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 导出分类型
    exportFun (type) {
      if (type === 1) {
        this.masterList.tableQuery.search.isPicUrl = 1
      } else {
        this.masterList.tableQuery.search.isPicUrl = 0
      }
      this.batchExport(this.masterList)
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreVisitReportGoodKeepExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
